import { SearchableDecisionInstantSearch } from '@livv/models';
import { completePreviewLink, getDecisionLink } from '@livv/utils/helpers';
import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';
import ContentCard, { PreviewCardProps } from './ContentCard';
import { APP_URL } from '@utils/consts/livv';
import { getFullTextSearchQuery } from '@utils/search/snippet';
import { AttributeType } from '@utils/types/search';

interface DecisionPreviewProps extends PreviewCardProps<SearchableDecisionInstantSearch> {
    filters?: string;
    query: string;
}

const DecisionPreview: FC<DecisionPreviewProps> = ({ filters, hit, query }) => {
    const { t } = useTranslation('decision');
    const { baseObjectID, result } = hit;
    const baseHref = getDecisionLink(baseObjectID);

    return (
        <ContentCard
            filters={filters}
            hit={hit}
            href={completePreviewLink(baseHref, APP_URL, getFullTextSearchQuery(hit, query))}
            query={query}
            secondaryAttributes={[
                {
                    attribute: 'sameCaseTitles',
                    attributeType: AttributeType.HIGHLIGHT,
                    label: t('sameCase'),
                },
            ]}
            snippetAttribute="fullText"
            subtitleAttributes={[
                {
                    attribute: 'subtitle',
                    attributeType: AttributeType.HIGHLIGHT,
                },
            ]}
            tags={result ? [result] : []}
            titleAttribute="title"
        />
    );
};

export default DecisionPreview;
